module.exports = __webpack_public_path__ + "static/media/dr.d4002916.jpeg";